export const DISPLAY_ALERT = 'SHOW_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';

// export const LOGIN_USER_BEGIN = 'LOGIN_USER_BEGIN';
// export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
// export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';

// export const REGISTER_USER_BEGIN = 'REGISTER_USER_BEGIN';
// export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
// export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';

export const CHANGE_COMPANY_NAME_BEGIN = 'CHANGE_COMPANY_NAME_BEGIN';
export const CHANGE_COMPANY_NAME_SUCCESS = 'CHANGE_COMPANY_NAME_SUCCESS';

export const LOGOUT_USER_BEGIN = 'LOGOUT_USER_BEGIN';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export const CREATE_COMPANY_BEGIN = 'CREATE_COMPANY_BEGIN';
export const CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS';
export const CREATE_COMPANY_ERROR = 'CREATE_COMPANY_ERROR';

export const LOGOUT_COMPANY = 'LOGOUT_COMPANY';

export const SWITCH_COMPANY_BEGIN = 'SWITCH_COMPANY_BEGIN';
export const SWITCH_COMPANY_SUCCESS = 'SWITCH_COMPANY_SUCCESS';
export const SWITCH_COMPANY_ERROR = 'SWITCH_COMPANY_ERROR';

export const SWITCH_COMPANY_TO_PROFILE_BEGIN = 'SWITCH_COMPANY_TO_PROFILE_BEGIN';
export const SWITCH_COMPANY_TO_PROFILE_SUCCESS = 'SWITCH_COMPANY_TO_PROFILE_SUCCESS';
export const SWITCH_COMPANY_TO_PROFILE_ERROR = 'SWITCH_COMPANY_TO_PROFILE_ERROR';

export const SWITCH_UNCLAIMED_PROFILE_BEGIN = 'SWITCH_UNCLAIMED_PROFILE_BEGIN';
export const SWITCH_UNCLAIMED_PROFILE_SUCCESS = 'SWITCH_UNCLAIMED_PROFILE_SUCCESS';
export const SWITCH_UNCLAIMED_PROFILE_ERROR = 'SWITCH_UNCLAIMED_PROFILE_ERROR';

// export const VERIFY_EMAIL_BEGIN = 'VERIFY_EMAIL_BEGIN';
// export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
// export const VERIFY_EMAIL_ERROR = 'VERIFY_EMAIL_ERROR';
